export default __webpack_public_path__ + "static/media/form-background.c7d02188.svg";